import { useState, useEffect, useCallback } from "react";
import { useAuthDetails } from "../Common/cookiesHelper";

const useMultiSelectForDashDaterange = (
  options,
  userTypeData,
  merchantData,
  dateRange,
  fetchData
) => {
  const { LoginGetDashBoardRecordJson } = useAuthDetails();
  const { merchant_id } = LoginGetDashBoardRecordJson?.data;

  const StoreName = !!LoginGetDashBoardRecordJson?.data?.name
    ? LoginGetDashBoardRecordJson?.data?.name
    : "";
  const [selectedItems, setSelectedItems] = useState(options);
  const [allOptionSelected, setAllOptionSelected] = useState(false);

  const getDefaultStore = useCallback(() => {
    if (Array.isArray(options) && options.length > 0) {
      const byMerchantId = options.find(
        (opt) => String(opt?.id) === String(merchant_id)
      );
      if (byMerchantId) return byMerchantId;

      const byName = options.find(
        (opt) => String(opt?.name || "").trim() === String(StoreName || "").trim()
      );
      if (byName) return byName;

      return options[0];
    }
    return {
      merchant_id: merchant_id,
      name: StoreName,
      id: merchant_id,
    };
  }, [options, merchant_id, StoreName]);

  useEffect(() => {
    // Initialize default store selection only when merchant/session context changes.
    // Don't reset on every render/options object identity change.
    setSelectedItems((prev) => {
      if (Array.isArray(prev) && prev.length > 0) return prev;
      return [getDefaultStore()];
    });
    setAllOptionSelected(false);
  }, [merchant_id, StoreName, getDefaultStore]);

  useEffect(() => {
    if (!Array.isArray(options) || options.length === 0) return;
    const hasValidSelected = selectedItems.some((item) =>
      options.some((opt) => String(opt?.id) === String(item?.id))
    );
    if (!hasValidSelected) {
      setSelectedItems([getDefaultStore()]);
      setAllOptionSelected(false);
    }
  }, [options, selectedItems, getDefaultStore]);

  const setSelectedItemsExternal = (items = []) => {
    const nextItems = Array.isArray(items) ? items : [];
    if (nextItems.length === 0) {
      setSelectedItems([getDefaultStore()]);
      setAllOptionSelected(false);
      return;
    }
    setSelectedItems(nextItems);
    setAllOptionSelected(
      options.length > 0 && nextItems.length === options.length
    );
  };

  const handleOptionClick = (selectedItem) => {
    if (selectedItem === "All") {
      if (selectedItems.length === options.length) {
        // Deselect all -> keep logged-in store selected
        setSelectedItems([getDefaultStore()]);
        setAllOptionSelected(false);
      } else {
        // Select all
        const selectAll = options.map((item) => ({ ...item }));
        setAllOptionSelected(true);
        setSelectedItems(selectAll);
        updateData([]);
      }
    } else {
      const isSelected = selectedItems?.some(
        (item) => item.id === selectedItem.id
      );
      if (isSelected) {
        // Deselect the specific item
        const updatedItems = selectedItems.filter(
          (item) => item.id !== selectedItem.id
        );
        if (updatedItems.length === 0) {
          const fallbackStore = getDefaultStore();
          setSelectedItems([fallbackStore]);
          setAllOptionSelected(false);
          updateData([fallbackStore]);
          return;
        }
        setSelectedItems(updatedItems);
        setAllOptionSelected(false);
        updateData(updatedItems);
      } else {
        // Select the specific item
        const updatedItems = [...selectedItems, selectedItem];
        const allSelected = updatedItems.length === options.length;
        setSelectedItems(updatedItems);
        setAllOptionSelected(allSelected && options.length > 1 ? true : false);
        updateData(updatedItems);
      }
    }
  };
  // -------------------------get all record based on selected checkbox---------

  const handleGetAllCheckboxId = (selectedData) => {
    let selectAllId = [];
    if (selectedData === "All") {
      if (selectedItems.length !== options.length) {
        let getCheckedAllId = options.map((item) => item);
        selectAllId = selectAllId.concat(selectAllId, ...getCheckedAllId);
        setAllOptionSelected(true);
      } else {
        selectAllId = [];
        setAllOptionSelected(false);
      }
    } else {
      selectAllId = selectedItems.includes(selectedData)
        ? selectedItems.filter((item) => item !== selectedData)
        : selectAllId.concat(selectedItems, selectedData);
      if (selectAllId.length === options.length) {
        setAllOptionSelected(true);
      } else {
        setAllOptionSelected(false);
      }
    }

    // const result =
    //   selectAllId.length > 0
    //     ? selectAllId.map((item) => item.title).join(", ")
    //     : "All";
    setSelectedItems(selectAllId);
    // console.log("result", result);
  };

  // -------------------------get all record based on selected checkbox---------

  const updateData = (updatedItems) => {
    void updatedItems;
    // if (data) {
    //   fetchData(data);
    // }
  };

  return {
    selectedItems,
    allOptionSelected,
    handleOptionClick,
    handleGetAllCheckboxId,
    setSelectedItemsExternal,
    options,
  };
};

export default useMultiSelectForDashDaterange;
